import React from 'react';
import styled from 'styled-components';
import { ErrorMessage } from 'formik';
import ErrorWrapper from './wrapper/ErrorWrapper';

const Fieldset = styled.fieldset`
  padding: 0;
  margin: 0;
  margin-bottom: ${props => props.theme.paddingS};
  border-width: 0;
`

const Legend = styled.legend`
  padding: 0;
  margin-bottom: ${props => props.theme.paddingXS};
  color: ${props => props.theme.primaryText};
`

const FieldGroup = (props) => (
  <Fieldset name={props.name}>
    {
      props.label &&
      <Legend>
        <strong>{props.label}</strong>
      </Legend>
    }

    {props.children}

    <ErrorMessage name={props.name} component={ErrorWrapper} />
  </Fieldset>
);

export default FieldGroup;
